import { Box } from 'theme-ui';

export const NoUpdates: React.FC = () => (
  <Box as='section' sx={{ padding: '0.5rem 0' }}>
    На этой неделе пока обновлений нет, но наши сотрудники работают над нотами и
    сайтом, поэтому возвращайтесь опять, и вы найдёте что-то новое!
  </Box>
);
